var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: true } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("carpass-observation-tire"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: {
                          label: _vm.$ct("carpass-tire-brand"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.brand,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "brand", $$v)
                          },
                          expression: "value.brand",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          label: _vm.$ct("carpass-tire-size"),
                          min: 8,
                          max: 30,
                          decimals: 0,
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.size,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "size", $$v)
                          },
                          expression: "value.size",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          label: _vm.$ct("carpass-tire-type"),
                          fancy: "",
                          items: _vm.tireTypeItems,
                        },
                        model: {
                          value: _vm.value.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "type", $$v)
                          },
                          expression: "value.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          label: _vm.$ct("carpass-tire-quantity"),
                          min: 1,
                          max: 6,
                          decimals: 0,
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.quantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "quantity", $$v)
                          },
                          expression: "value.quantity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }